// token存储
export const STORAGE_TOKEN_KEY = 'lbChatToken'

// 登录成功后要干的事情(打开登录框之前设置)
export const STORAGE_LOGIN_SUCCESS_COMMAND_PRE = 'STORAGE_LOGIN_SUCCESS_COMMAND_PRE'

// 登录成功后要干的事情(打开登录框之后设置)
export const STORAGE_LOGIN_SUCCESS_COMMAND_AFTER = 'STORAGE_LOGIN_SUCCESS_COMMAND_AFTER'